<div class="Card Statistikmonitor" style="padding:20px">

    <h1>STATISTIKMONITOR Rhein-Neckar</h1>


    <div style="font-size:1.05em">

        <p>
            Die Metropolregion Rhein-Neckar GmbH (MRN GmbH) und der Verband Region Rhein-Neckar (VRRN) verfolgen das Ziel, die Metropolregion Rhein-Neckar (MRN) bis zum Jahre 2025 zu einer der attraktivsten und wettbewerbsfähigsten Regionen Europas zu entwickeln. Grundvoraussetzung hierfür ist es, sich hinsichtlich strategisch bedeutsamer Merkmale jederzeit ein genaues Bild von der Lage und den Entwicklungstendenzen in der Region machen zu können. Diesem Ziel dient auch der von der MRN GmbH und dem VRRN bereitgestellte STATISTIKMONITOR Rhein-Neckar. Der Hauptfokus ist auf die Situation in den 15 Teilräumen der MRN (Kreisebene) gerichtet; um die Position der MRN als Ganzes einschätzen zu können, werden zum Vergleich zudem immer auch die Werte überregionaler Raumeinheiten angezeigt.
        </p>

        <p>
            Im STATISTIKMONITOR werden vier Module bereitgestellt:
        </p>
        <ul>
            <li>
                <h3>"Strukturindikatoren"</h3>
                Daten zum Vergleich der aktuellen Situation in den MRN-Teilräumen (Relativwerte)

            </li>
            <li>
                <h3>"Dynamikindikatoren"</h3>
                Entwicklungstendenzen in einem Fünfjahreszeitraum (+/- %)
            </li>
            <li>
                <h3>"TOP-Indikatoren"</h3>
                Übersichtsblatt für jede MRN-Raumeinheit mit ausgewählten Indikatoren (Relativwerte)
            </li>
            <li>
                <h3>"Absolutwerte"</h3>
                Planungsrelevante Absolutwerte in Tabellenform (i.d.R. Zeitreihen)
            </li>
        </ul>

        <p>
            In Deutschland gibt es 11 "Europäische Metropolregionen". Eckdaten zur Situation in den Metropolregionen sind in dem vom "Initiativkreis Europäische Metropolregionen in Deutschland - IKM" bereitgestellten "Regionalen Monitoring" abzurufen:
            <a href="https://deutsche-metropolregionen.org/#monitoring" target="_blank">https://deutsche-metropolregionen.org/#monitoring</a> (Stand: 21.02.2022)
        </p>

        <p>
            Die Aktualisierung aller Daten im STATISTIKMONITOR erfolgt im jährlichen Rhythmus. Die Beschreibung der "aktuellsten" Situation in den MRN-Teilräumen erfolgt auf Basis der zu einem Stichtag vorliegenden aktuellsten verfügbaren Werte. Da die Daten von den Datenlieferanten zu unterschiedlichen Zeiten und mit unterschiedlicher Zeitverzögerung bereitgestellt werden, sind unterschiedliche Indikator-spezifische Zeitbezüge der Fall.
        </p>
    </div>



</div>